export default __webpack_public_path__ + "static/media/frog.88df5571.png";